import { ParsedUrlQuery } from 'querystring';

/**
 * Retrieves the value of the specified query parameter from the parsed URL query object.
 * @param {ParsedUrlQuery} query - The parsed URL query object.
 * @param {string} param - The name of the query parameter to retrieve.
 * @returns {string | undefined} - The value of the query parameter if found, or undefined if not found.
 */
export const getQueryParam = (query: ParsedUrlQuery, param: string) => {
  const parsedParam = query?.[param];
  if (typeof parsedParam === 'string') {
    return parsedParam;
  }
};
